export default function getXY(e) {
    let xy
    if (typeof e.clientX !== 'undefined') {
        xy = e as MouseEvent
    } else if (e.changedTouches.length) {
        xy = (e as TouchEvent).changedTouches[0]
    }
    const { clientX, clientY } = xy
    return { clientX, clientY }
}
